// sub/ = 읽기 전용 구독 소스들 ({Provider}{Mode}Source), mode별 폴더(direct/gateway). pub은 domain/stream/pub/.
import ChzzkDirectSource from "./sub/direct/ChzzkDirectSource";
import TwitchDirectSource from "./sub/direct/TwitchDirectSource";
import VirtupetGatewaySource from "./sub/gateway/VirtupetGatewaySource";
import ChzzkGatewaySource from "./sub/gateway/ChzzkGatewaySource"; // DEPRECATED 폴백 (direct 검증 후 제거)

// 활성 소스를 모아 kind별 핸들러로 라우팅.
// 소비자(Reaction/Page)는 source의 provider·mode를 모르고 kind로만 받는다(불변식).
//   kind="event-stream" → StreamEvent (단일 인터프리터가 type으로 해석)
//     chzzk(CHAT/DON/SUB) · virtupet(V-INSTRUCTION + 잔여 제어 op) 모두 event-stream.
export class StreamRegistry {
  constructor() {
    this._routes = {};
    this._sources = [];
  }

  route(kind, handler) {
    this._routes[kind] = handler;
    return this;
  }

  add(source) {
    source.on((payload) => {
      const handler = this._routes[source.kind];
      if (handler) handler(payload, source.provider); // provider 전달(피드에서 출처 표시용)
    });
    this._sources.push(source);
    return source; // open/close 타이밍은 호출측이 제어
  }

  closeAll() {
    this._sources.forEach((s) => s.close());
    this._sources = [];
  }
}

export { ChzzkDirectSource, TwitchDirectSource, VirtupetGatewaySource, ChzzkGatewaySource };
